// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const CardFooter = styled.div``;

// #####################################################
